import NoteCollapse from './NoteCollapse';

export default NoteCollapse;
